import isNil from 'lodash/isNil'
const state = {
    period: null,
    periodFilter: false,
    user: null,
    search: null
};

const getters = {
    isPeriodFilterActive: (state) => (fallback) => {
        return !isNil(state.periodFilter) ? state.periodFilter : fallback
    },
    getPeriod: (state) => (fallback) => {
        return !isNil(state.period) ? state.period : fallback
    },
    getUser: (state) => (fallback) => {
        return !isNil(state.user) ? state.user : fallback
    },
    getSearch: (state) => (fallback) => {
        return !isNil(state.search) ? state.search : fallback
    },
};

const mutations = {
    setPeriod: (state, payload) => {
        state.period = payload;
    },
    setPeriodFilterActive: (state, payload) => {
        state.periodFilter = payload;
    },
    setUser: (state, payload) => {
        state.user = payload;
    },
    setSearch: (state, payload) => {
        state.search = payload;
    }
};

// if This will not work we will need to save it in a constant Namespace
export default {
    namespaced: true,
    state,
    getters,
    mutations
};
